module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'club-picker-wrap': true, tall: _vm.allowUnattached || _vm.allowInternational
    }
  }, [_c('input', {
    attrs: {
      "name": _vm.fieldName,
      "required": _vm.orgMode != 'unattached',
      "type": "hidden"
    },
    domProps: {
      "value": Object.keys(_vm.output).length > 0 && JSON.stringify(_vm.output) || JSON.stringify(_vm.text)
    }
  }), _vm._v(" "), (_vm.allowUnattached || _vm.allowInternational) ? _c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orgMode),
      expression: "orgMode"
    }],
    attrs: {
      "name": "org_mode",
      "type": "radio",
      "value": "affiliated"
    },
    domProps: {
      "checked": _vm._q(_vm.orgMode, "affiliated")
    },
    on: {
      "click": function($event) {
        _vm.orgMode = "affiliated"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.orgType))]), _vm._v(" "), (_vm.allowUnattached) ? _c('label', {
    staticClass: "form-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orgMode),
      expression: "orgMode"
    }],
    attrs: {
      "name": "org_mode",
      "type": "radio",
      "value": "unattached"
    },
    domProps: {
      "checked": _vm._q(_vm.orgMode, "unattached")
    },
    on: {
      "click": function($event) {
        _vm.orgMode = "unattached"
      }
    }
  }), _vm._v(" Unattached")]) : _vm._e(), _vm._v(" "), (_vm.allowInternational) ? _c('label', {
    staticClass: "form-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orgMode),
      expression: "orgMode"
    }],
    attrs: {
      "name": "org_mode",
      "type": "radio",
      "value": "international"
    },
    domProps: {
      "checked": _vm._q(_vm.orgMode, "international")
    },
    on: {
      "click": function($event) {
        _vm.orgMode = "international"
      }
    }
  }), _vm._v(" Foreign Club")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.orgMode == 'international' && _vm.allowInternational) ? _c('fieldset', {
    staticClass: "form-group col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.currentCountry),
      expression: "currentCountry",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.currentCountry = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.code
      }
    }, [_vm._v(_vm._s(country.name))])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [((!_vm.allowUnattached) || (_vm.orgMode !== 'unattached')) ? _c('div', {
    class: {
      'open': _vm.openSuggestion
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "form-control",
    attrs: {
      "required": _vm.orgMode == 'affiliated',
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.text)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }, function($event) {
        _vm.updateValue($event.target.value)
      }],
      "keydown": [function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.enter($event)
      }, function($event) {
        if (_vm._k($event.keyCode, "down", 40)) { return; }
        _vm.down($event)
      }, function($event) {
        if (_vm._k($event.keyCode, "up", 38)) { return; }
        _vm.up($event)
      }, function($event) {
        if (_vm._k($event.keyCode, "esc", 27)) { return; }
        _vm.open = false
      }]
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.matches), function(suggestion, index) {
    return _c('li', {
      class: {
        'active': _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          _vm.suggestionClick(index)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(suggestion.code) + " "), _c('small', [_vm._v(_vm._s(suggestion.name))])])])
  }))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-423f0983!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClubPicker.vue
// module id = 309
// module chunks = 2